import React, { useState } from 'react';
import { TextField, Grid, Typography, IconButton, InputAdornment, CircularProgress } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import axios from 'axios';
import { showToast } from '../../utils/toastUtils';
import ActionButton from '../../components/ActionButton';
import { useSelector } from 'react-redux';

const SecuritySettings = () => {
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [showPassword, setShowPassword] = useState({
    currentPassword: false,
    newPassword: false,
    confirmPassword: false,
  });
  const [loading, setLoading] = useState(false);
  
  const userIdFromRedux = useSelector(state => state.onboarding.userId);
  const userId = userIdFromRedux || localStorage.getItem('userId');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleClickShowPassword = (field) => {
    setShowPassword({ ...showPassword, [field]: !showPassword[field] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userId) {
      showToast('User not found. Please log in again.', 'error');
      return;
    }
    if (formData.newPassword !== formData.confirmPassword) {
      showToast('New passwords do not match', 'error');
      return;
    }
    setLoading(true);
    try {
      const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/user/${userId}/change-password`, {
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword
      });
      if (response.data.message === 'Password changed successfully') {
        showToast('Password changed successfully', 'success');
        setFormData({ currentPassword: '', newPassword: '', confirmPassword: '' });
      } else {
        showToast(response.data.message || 'Error changing password', 'error');
      }
    } catch (error) {
      showToast(error.response?.data?.message || 'Error changing password', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
        <Typography variant="h6" gutterBottom>Security Settings</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Current Password"
              name="currentPassword"
              type={showPassword.currentPassword ? 'text' : 'password'}
              value={formData.currentPassword}
              onChange={handleChange}
              required
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => handleClickShowPassword('currentPassword')}
                      edge="end"
                    >
                      {showPassword.currentPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="New Password"
              name="newPassword"
              type={showPassword.newPassword ? 'text' : 'password'}
              value={formData.newPassword}
              onChange={handleChange}
              required
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => handleClickShowPassword('newPassword')}
                      edge="end"
                    >
                      {showPassword.newPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Confirm New Password"
              name="confirmPassword"
              type={showPassword.confirmPassword ? 'text' : 'password'}
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => handleClickShowPassword('confirmPassword')}
                      edge="end"
                    >
                      {showPassword.confirmPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <ActionButton
              text={loading ? <CircularProgress size={24} /> : 'change'}
              onClick={handleSubmit}
            />
          </Grid>
        </Grid>
      </form>
  );
};

export default SecuritySettings;
